if (!customElements.get('image-content')) {
  customElements.define('image-content', class ImageContent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('.js-image-content-button')
      const contentMore = this.querySelector('.js-image-content-content-more')

      if (button) {
        button.addEventListener('click', () => {
          this.classList.toggle('is-expanded')
          button.setAtrribute('aria-expanded', this.classList.has('is-expanded'))
        })
      }

      if (contentMore) {
        const contentMoreInner = contentMore.querySelector('.js-image-content-content-more-inner')
        const updateMaxHeight = () => {
          this.style.setProperty('--content-more-height', `${contentMoreInner.offsetHeight}px`)
        }

        updateMaxHeight()
        window.addEventListener('resize', updateMaxHeight)
      }
    }
  });
}